/**
 * Utilidades para generar códigos de invitación más amigables
 */

export const generateFriendlyInviteCode = (prefix: string = 'CARE'): string => {
  const year = new Date().getFullYear()
  const randomPart = Math.random().toString(36).substring(2, 5).toUpperCase()
  const timestamp = Date.now().toString(36).substring(-3).toUpperCase()
  
  return `${prefix}-${year}-${randomPart}${timestamp}`
}

export const generateCaregiverInviteCode = (): string => {
  return generateFriendlyInviteCode('CARE')
}

export const generatePatientInviteCode = (): string => {
  return generateFriendlyInviteCode('PATIENT')
}

export const generateDemoInviteCode = (): string => {
  return generateFriendlyInviteCode('DEMO')
}

// Validar formato de código amigable
export const isValidFriendlyCode = (code: string): boolean => {
  // Formato: PREFIX-YYYY-ABCDEF
  const friendlyPattern = /^[A-Z]+-\d{4}-[A-Z0-9]{6}$/
  return friendlyPattern.test(code)
}

// Validar formato de código legacy (para compatibilidad)
export const isValidLegacyCode = (code: string): boolean => {
  // Formato antiguo: cadena alfanumérica de 12+ caracteres
  const legacyPattern = /^[a-zA-Z0-9]{12,}$/
  return legacyPattern.test(code)
}

// Validar cualquier formato de código
export const isValidInviteCode = (code: string): boolean => {
  return isValidFriendlyCode(code) || isValidLegacyCode(code)
}

// Formatear código para visualización
export const formatCodeForDisplay = (code: string): string => {
  // Si es formato nuevo, no cambiar
  if (isValidFriendlyCode(code)) {
    return code
  }
  
  // Si es formato legacy, agregar guiones cada 4 caracteres
  if (isValidLegacyCode(code)) {
    return code.match(/.{1,4}/g)?.join('-') || code
  }
  
  return code
}

// Limpiar código para búsqueda en base de datos
export const cleanCodeForSearch = (code: string): string => {
  // Remover guiones y espacios, convertir a mayúsculas
  return code.replace(/[-\s]/g, '').toUpperCase()
}